import { render, staticRenderFns } from "./FacetRefinementList.vue?vue&type=template&id=b79d2100"
import script from "./FacetRefinementList.vue?vue&type=script&setup=true&lang=js"
export * from "./FacetRefinementList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports